// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"AtCompanyPrivate_lockIcon__29R6o","title":"AtCompanyPrivate_title__2aqkY","description":"AtCompanyPrivate_description__2CJ-o"};